import { MedicationRow } from "../../api/medication.type";
import Card from "../shared/card";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDate } from "../utls/time";

interface MedicationItemProps {
  medication: MedicationRow;
}

export default function MedicationItem({ medication }: MedicationItemProps) {
  const {
    dosage,
    dosageUnit,
    frequency,
    route,
    instructions,
    duration,
    refills,
    startDate,
    endDate,
    reason,
    pharmacyNotes,
    status,
    effectiveFrom,
    effectiveTo,
    createdAt,
  } = medication as any;

  const renderDate = (iso?: string | null) => {
    if (!iso || iso === "infinity") return null;
    return formatTimeStampToHumanReadableDate(iso);
  };

  return (
    <Card variant="cream" elevation={1} className="max-w-4xl">
      <Card.Body className="space-y-1">
        {reason && (
          <Typography variant="subtitle1" className="text-brown-800">
            {reason}
          </Typography>
        )}
        {(dosage || dosageUnit) && (
          <Typography variant="body2" className="text-brown-800">
            Dosage: {dosage} {dosageUnit}
          </Typography>
        )}
        {frequency && (
          <Typography variant="body2" className="text-brown-800">
            Frequency: {frequency}
          </Typography>
        )}
        {route && (
          <Typography variant="body2" className="text-brown-800">
            Route: {route}
          </Typography>
        )}
        {instructions && (
          <Typography variant="body2" className="text-brown-800">
            Instructions: {instructions}
          </Typography>
        )}
        {duration && (
          <Typography variant="body2" className="text-brown-800">
            Duration: {duration}
          </Typography>
        )}
        {typeof refills !== "undefined" && (
          <Typography variant="body2" className="text-brown-800">
            Refills: {refills}
          </Typography>
        )}
        {renderDate(startDate) && (
          <Typography variant="body2" className="text-brown-800">
            Start Date: {renderDate(startDate)}
          </Typography>
        )}
        {renderDate(endDate) && (
          <Typography variant="body2" className="text-brown-800">
            End Date: {renderDate(endDate)}
          </Typography>
        )}
        {pharmacyNotes && (
          <Typography variant="body2" className="text-brown-800">
            Notes: {pharmacyNotes}
          </Typography>
        )}
        {status && (
          <Typography variant="body2" className="text-brown-800">
            Status: {status}
          </Typography>
        )}
        {renderDate(effectiveFrom) && (
          <Typography variant="caption" className="text-brown-600">
            Effective From: {renderDate(effectiveFrom)}
          </Typography>
        )}
        {renderDate(effectiveTo) && (
          <Typography variant="caption" className="text-brown-600">
            Effective To: {renderDate(effectiveTo)}
          </Typography>
        )}
        {renderDate(createdAt) && (
          <Typography variant="caption" className="text-brown-600">
            Added: {renderDate(createdAt)}
          </Typography>
        )}
      </Card.Body>
    </Card>
  );
}
